module.exports = __webpack_public_path__ + "static/media/IntroToReact.9a1587ca.png";